module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Food/Chicken-860d965d0c704a88df5af9d96364e3dd.svg";